import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as boatActions from 'store/actions/boat';

import Details from './Details';
import New from './New';

const mapStateToProps = state => ({
  boat: state.boat
});

const mapDispatchToProps = dispatch => ({
  setBoatDetails: bindActionCreators(boatActions.setBoatDetails, dispatch),
  clearBoatDetails: bindActionCreators(boatActions.clearBoatDetails, dispatch),
  updateBoatDetails: bindActionCreators(boatActions.updateBoatDetails, dispatch)
});

@connect(mapStateToProps, mapDispatchToProps)
export default class BoatManufacturer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      boatDetailsRequestInProcess: !(props.match.params.applicationId === 'new'),
    };
  }

  componentDidMount() {
    const { setBoatDetails, match } = this.props;

    if (isFinite(match.params.applicationId)) {
      setBoatDetails(match.params.applicationId).then(() => this.setState({ boatDetailsRequestInProcess: false }));
    }
  }

  componentWillUnmount() {
    this.props.clearBoatDetails();
  }

  render() {
    const { match, user } = this.props;
    const { boatDetailsRequestInProcess } = this.state;

    if (boatDetailsRequestInProcess)
      return (
        <section className='scene__scene-wrapper'>
          <section className={'scene__content-wrapper'}>
            <section className='scene__scene-header detailsScene__scene-header'>
              <div
                className='go-back-to-list-header-button'
                onClick={() => {
                  user.goToList();
                }}
              >
                Back
              </div>
              <header>Boat Details</header>
            </section>
            <section className='scene_section _height_100'>
              <div className='ect-spinner'>
                <figure className='ect-spinner__image' style={{ width: 50, height: 50 }} />
              </div>
            </section>
          </section>
        </section>
      );

    return (
      <Switch>
        <Route
          exact
          path={`${match.path}`}
          render={({ match }) => (
            <Details {...this.props} match={match} boatDetailsRequestInProcess={boatDetailsRequestInProcess} />
          )}
        />
        <Route exact path={`${match.path}/:step`} render={({ match }) => <New {...this.props} match={match} />} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/index.jsx